// extracted by mini-css-extract-plugin
export default {"melodyVideo":"wP-z","isFullWidth":"xP-z","landingPageVideo":"yP-z","play":"zP-z","iframeVideo":"AP-z","playHidden":"BP-z","fullwidth":"CP-z"};